var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photograph-warpper"},[_c('img',{staticClass:"paishe",attrs:{"src":_vm.page.photoImgUrl,"alt":""}}),_vm._v(" "),_c('p',[_vm._v("拍摄时正对标识 尽量满屏、清晰。")]),_vm._v(" "),_c('img',{staticClass:"gif",attrs:{"src":_vm.page.gifUrl,"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39cf70d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Photograph/index.vue
// module id = null
// module chunks = 